import CSRPolicy from "../assets/policy_pdf/1CSR_Policy.pdf";
import RelatedPolicy from "../assets/policy_pdf/3Related_Party_Transaction_Policy.pdf";
import FraudPolicy from "../assets/policy_pdf/4FRAUD_PREVENTION_and_RISK_MAGT_POLICY.pdf";
import NRCPolicy from "../assets/policy_pdf/5NRC_policy.pdf";
import fpcHindi from "../assets/code_of_conduct_pdf/fair_practice_code_hindi.pdf";
import fpcEnglish from "../assets/code_of_conduct_pdf/fair_practice_code_english.pdf";
import egmNotis from "../assets/egm_notice_pdf/BSML_3rdEGM_notice.pdf";
import egmNotis1 from "../assets/egm_notice_pdf/BSML_EGM notice 31.08.2026.pdf";
import POSHPolicy from "../assets/policy_pdf/6POSH policy.pdf";
import VIGILPolicy from "../assets/policy_pdf/7VIGIL MECHANISM & WHISTLE BLOWER POLICY.pdf";
import BCMS from "../assets/policy_pdf/8BSML_BCMS_Aligned_Business_Continuity_Policy_and_Plan 22.04.2026.pdf";
import ITOutsourcing from "../assets/policy_pdf/9BSML_IT_Outsourcing_and_TPRM_Policy_22.04.2026.pdf";
import Annual_Return from "../assets/annual_return_pdf/Annual_return_MGT-7_FY26.pdf";
export const ReportsData = {
  page: [
    {
      title: "Annual Report",
      sections: [],
    },
    {
      title: "Policies",
      sections: [
        {
          id: 1,
          year: "FY 2024-25",
          title: "CSR Policy",
          url: CSRPolicy,
          icon: "📄",
        },
        {
          id: 2,
          year: "FY 2023-24",
          title: "Related Party Transaction Policy",
          url: RelatedPolicy,
          icon: "📄",
        },
        {
          id: 3,
          year: "FY 2023-24",
          title: "Fraud Prevention And Risk Magt Policy",
          url: FraudPolicy,
          icon: "📄",
        },
        {
          id: 4,
          year: "FY 2023-24",
          title: "NRC Policy",
          url: NRCPolicy,
          icon: "BsFileEarmarkPdf",
        },
        {
          id: 5,
          year: "FY 2023-24",
          title: "POSH Policy",
          url: POSHPolicy,
          icon: "BsFileEarmarkPdf",
        },
        {
          id: 6,
          year: "FY 2023-24",
          title: "VIGIL MECHANISM & WHISTLE BLOWER POLICY",
          url: VIGILPolicy,
          icon: "BsFileEarmarkPdf",
        },
        {
          id: 7,
          year: "FY 2026-27",
          title: "Business Continuity & Disaster Recovery Policy",
          url: BCMS,
          icon: "BsFileEarmarkPdf",
        },
        {
          id: 8,
          year: "FY 2026-27",
          title: "IT Outsourcing & Third-Party Risk Management Policy",
          url: ITOutsourcing,
          icon: "BsFileEarmarkPdf",
        },
      ],
    },
    {
      title: "Regulatory filings",
      sections: [],
    },
    {
      title: "EGM Notice",
      sections: [
        {
          id: 1,
          title: "EGM Notice FY 2025-26",
          url: egmNotis,
          icon: "📄",
        },
        {
          id: 2,
          title: "EGM Notice FY 2026-27",
          url: egmNotis1,
          icon: "📄",
        },
      ],
    },
    {
      title: "Code of conduct",
      sections: [
        {
          id: 1,
          title: "Fair Practice Code English",
          url: fpcEnglish,
          icon: "📄",
        },
        {
          id: 2,
          year: "FY 2024-25",
          title: "Fair Practice Code Hindi",
          url: fpcHindi,
          icon: "📄",
        },
      ],
    },
    {
      title: "News and events",
      sections: [],
    },
    {
      title: "Annual Return",
      sections: [
         {
          id: 1,
          title: "Annual Return MGT-7 FY26",
          url: Annual_Return,
          icon: "📄",
        },
      ],
    },
  ],
};
